export function filterOptions(options, filterString) {
    if (!options.length || !filterString) {
        return options;
    }
    return options.filter((o) => o.name.toLocaleLowerCase().indexOf(filterString.toLowerCase().trim()) !== -1);
}
export function uniqueOptionsById(options) {
    return options.reduce((prev, item) => (prev.some((i) => i.id === item.id) ? prev : [...prev, item]), []);
}
